<template>
  <el-container class="SaleStatPrint">
    <el-main ref="printArea" class="p-0 printArea">      
      <div class="w-full title-bar">매 출 현 황</div>
      <div class="table-fixed">
      <ATable
        ref="table"
        size="mini"
        :loading="loading"
        :data="data"
        :spanMethod="handleSpanMethod"
        :rowClassName="handleRowClassName"
        border
        hide-pagination
        hideButtonExcel
        hide-button-insert
      >
        <el-table-column 
          prop="sale_date" 
          label="매출일"
          v-if="column.sale_date"
          width="100"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          v-if="column.customer_name"
        />
        <el-table-column 
          prop="product_name" 
          v-if="column.product_name"
          label="품목" 
          width="130"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="size" 
          label="Size" 
          v-if="column.size"
          width="60"
          show-overflow-tooltip 
        />
        <el-table-column
          prop="amount"
          label="수량"
          class-name="cell-number"
          v-if="column.amount"
          width="50"
          :formatter="util.numberFormat"
        />        
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          v-if="column.cost"
          width="70"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          v-if="column.supply_price"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          v-if="column.tax"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="합계금액"
          class-name="cell-number"
          v-if="column.price"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="collect_price"
          label="수금액"
          class-name="cell-number"
          v-if="stat_type === 2 && column.collect_price"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="balance"
          label="미결금"
          class-name="cell-number"
          v-if="stat_type === 2 && column.balance"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="created_user_name" 
          label="등록인"
          width="60"
          v-if="column.created_user_name"
        />
        <el-table-column 
          prop="desc" 
          label="비고"
          v-if="column.desc"
          show-overflow-tooltip 
        />
      </ATable>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import Print from "@/plugins/print/print";
import Vue from "vue";

Vue.use(Print);

export default {
  name: "SaleStatPrint",
  data() {
    return {
    };
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    stat_type: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleRowClassName({row}) {
      if (row.is_total_sum) { return 'warning-row'; }
      if (row.is_sum) { return 'success-row'; }
      return '';
    },
    handleSpanMethod({ row, /*rowIndex,*/ columnIndex }) {
      if (!row.is_sum && (columnIndex >= this.fix_column_length)) {
        return;
      }
      if (row.is_sum) {
        switch(columnIndex) {
          case 1:
            if (this.stat_type === 2) {
              return { rowspan: 1, colspan: 1 };
            } else {
              return { rowspan: 1, colspan: 4 };
            }
          case 2:
            if (this.stat_type === 2) {
              return { rowspan: 1, colspan: 3 };
            } else {
              return { rowspan: 0, colspan: 0 };
            }
          case 3:
          case 4:
            return { rowspan: 0, colspan: 0 };
          default:
            return;
        }
      }
      let span = row.rowspan.find(r => r.col === columnIndex);
      if (span) {
        if (span.span > 0) {
          return { rowspan: span.span, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      } else {
        return;
      }
    },
    handleClickPrint() {
      this.$print(this.$refs.printArea);
    },
    handleClickClose() {
      this.$emit('completed');
    },
  }
};
</script>
<style lang="scss">
@media print {
  .el-table .cell {
    font-size: 9px;
  }
}
</style>


